module.exports = __webpack_public_path__ + "static/flower-8987fcdb31559b022cf2df7f4a32104c.png";